import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        userInfo: {},
        departmentValueList: [],
        vendorValueList: [],
        purchasingAgentValueList: [],
        lineItemDescriptionValueList: [],
        trackingNumberValueList: [],
        trackingNumberOptions: [],
        currentPage: "",
        salesContactLookup: {},
        vendorKeyLookup: {}
    },


    getters: {
        hasAccessToAgencyRecords: state => {
            return state.userInfo.role == "Admin" || state.userInfo.role == "Service";
        },

        isAdmin: state => {
            return state.userInfo.role == "Admin";
        },

        isLoggedIn: state => {
            return state.userInfo.loggedIn;
        },

        isTokenExpired: state => {
            var now = new Date();
            var expirationDate = state.userInfo.expirationDate;
            if (expirationDate === undefined) {
                return true;
            }
            return now > expirationDate;
        }
    },


    mutations: {
        setUserData(state, payload) {
            state.userInfo = payload;
        },
        updateDepartmentValueList(state, payload){
             state.departmentValueList = payload;
        },
        updateVendorValueList(state, payload){
            state.vendorValueList = payload;
        },
        updatePurchasingAgentValueList(state, payload){
            state.purchasingAgentValueList = payload;
        },
        updateLineItemDescriptionValueList(state, payload){
            state.lineItemDescriptionValueList = payload;
        },
        updateTrackingNumberValueList(state, payload){
            state.trackingNumberValueList = payload;
        },
        updateTrackingNumberOptions(state, payload){
            state.trackingNumberOptions = payload;
        },
        updateSalesContactLookup(state, payload){
            state.salesContactLookup = payload;
        },
        updateVendorKeyLookup(state, payload){
            state.vendorKeyLookup = payload;
        },
        updateCurrentPage(state, payload){
            state.currentPage = payload;
        }
    },

    plugins: [
        createPersistedState({
            paths: ['userInfo', 'currentPage']
        })
    ]

});

export default store


// WEBPACK FOOTER //
// ./src/store/store.js